import React from 'react';

export const LogOutIcon: React.FC = () => (
	<svg width='1.9rem' height='2.1rem' viewBox='0 0 19 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M12.2857 3.90039V1.40039H1V19.4004H12.2857V17.5432' stroke='currentColor' strokeWidth='1.5' />
		<path d='M8.00122 10.8993H17.0012M17.0012 10.8993L13.7869 7.68506M17.0012 10.8993L13.7869 14.1136' stroke='currentColor' strokeWidth='1.5' />
	</svg>
);
